<!-- ukey用户密码签署 -->
<template>
    <el-dialog :title="title"
               :visible.sync="visible"
               width="480px"
               :before-close="doClose"
               :close-on-click-modal="showClose"
               :close-on-press-escape="showClose"
               :show-close="showClose"
               append-to-body
               custom-class="ukey-password-sign">

        <el-form :model="form"
                 ref="signForm"
                 :rules="rules">
            <el-form-item prop="pin">
                <el-input v-model="form.pin"
                          v-focus
                          @keydown.enter.native.stop.prevent="doConfirm"
                          :type="passwordVisible ? 'text':'password'"
                          placeholder="请输入法人一证通密码">
                    <div slot="append">
                        <span @click="passwordVisible = !passwordVisible">
                            <svg-icon :id="passwordVisible?'iconvisible':'iconinvisible'"
                                      style="fontSize:28px"></svg-icon>
                        </span>
                    </div>
                </el-input>
            </el-form-item>
        </el-form>

        <div slot="footer">
            <el-button type="default"
                       v-if="showClose"
                       size="medium"
                       @click="doClose">取消</el-button>
            <el-button type="primary"
                       size="medium"
                       @click="doConfirm">{{confirmText}}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import SvgIcon from '@/components/svg-icon.vue';

export default {
    name: 'UkeyPasswordSign',
    components: { SvgIcon },
    props: {
        visible: Boolean,
        confirmText: {
            type: String,
            default: '完成签署'
        },
        showClose: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            form: {
                pin: ''
            },
            passwordVisible: false,
            rules: {
                pin: [{ required: true, validator: this.validatePin, trigger: 'manual' }]
            }
        };
    },
    computed: {
        title () {
            return this.showClose ? '请输入法人一证通密码' : '请输入法人一证通密码初始化系统';
        },
    },
    inject: ['app'],
    methods: {
        /**
         * 校验USBKEY pin
         */
        async validatePin (rule, value, callback) {
            try {
                if (rule.required && !value) {
                    callback(new Error('请输入法人一证通密码'));
                }
                // IE浏览器兼容
                if (!this.Utils.isIE()) {
                    let resp = await this.app.ukey.verifyUserPin(value);
                    if (resp.code === 0) {
                        callback();
                    } else {
                        callback(new Error(resp.message));
                    }
                } else {
                    console.log('ie use init method to verify pin code', value);
                    // eslint-disable-next-line no-unused-vars
                    this.app.ukey.initService(value).then(res => {
                        callback();
                    }, rej => {
                        callback(new Error(rej.message));
                    });
                }
            } catch (error) {
                console.log('try catch', error);
                callback(error);
            }
        },

        /**
         * 关闭
         */
        doClose () {
            this.$emit('update:visible', false);
        },

        /**
         * 确认
         */
        async doConfirm () {
            try {
                await this.$refs['signForm'].validate();
                this.$emit('onConfirm', this.form.pin);
                this.doClose();
            } catch (error) {
                console.log(error);
            }
        }
    }
};
</script>


<style lang="less" scoped>
</style>
